import React from 'react';

import type { RouteMatch } from '@confluence/route';

import { SmartCreatePromptLoader } from '@confluence/smart-create/entry-points/SmartCreatePrompt';
import { CONTAINER_HOME_ID } from '@confluence/app-navigation/entry-points/navigationIDs';

export const SmartCreateRoute = (routeMatch: RouteMatch) => {
	return <SmartCreatePromptLoader spaceKey={(routeMatch?.query?.spaceKey as string) || ''} />;
};

SmartCreateRoute.NAVIGATION_PARAMS = (routeMatch: RouteMatch) => {
	const spaceKey = routeMatch?.query?.spaceKey ?? '';
	return {
		Screen: {
			screenEvent: {
				name: 'smartCreatePromptScreen',
			},
			pageState: { spaceKey, routeName: routeMatch.name },
		},
		MainLayout: {
			spaceKey,
			navView: CONTAINER_HOME_ID,
		},
	};
};
